import React from 'react';
import {BsGithub, BsInstagram, BsLinkedin} from 'react-icons/bs';
import {SiCodechef} from 'react-icons/si';

const SocialMedia = ({component}) => {
  return (
      !component ?
        <></>
      :
        <div className='app__social'>
          <a href='https://www.codechef.com/users/thakurprathya' target='__blank'><SiCodechef/></a>
          <a href='https://www.linkedin.com/in/prathya-thakur-370869231/' target='__blank'><BsLinkedin/></a>
          <a href='https://github.com/thakurprathya' target='__blank'><BsGithub/></a>
          <a href='https://www.instagram.com/thakurprathya/' target='__blank'><BsInstagram/></a>
        </div>
  )
}

export default SocialMedia;
